const STUDENT_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  NOT_PAID: 'Payment_Required'
};

export default STUDENT_STATUS;
